// extracted by mini-css-extract-plugin
export default {"dropdownCreateButton":"bestFitRegion_dropdownCreateButton__nTTqa","requestText":"bestFitRegion_requestText__G+djh"};